import React, { createContext, useState } from "react";
import { toast } from "react-toastify";

import { createTranscriptApi } from "../api/Writes";

export const NCETranscriptRequestContext = createContext(null);

const NCETranscriptRequestProvider = ({ children }) => {
  const [nceTranscriptInfo, setNceTranscriptInfo] = useState({});
  const [nceTranscriptOption, setNceTranscriptOption] = useState();
  const [copyType, setCopyType] = useState();
  const [requestType, setRequestType] = useState();
  const [nceTranscriptOrderNo, setNceTranscriptOrderNo] = useState("");

  //  create transcript
  const createTranscript = async (param) => {
    try {
      let response = await createTranscriptApi(param);
      if (response.success) {
        toast.success("Transcript saved successfully");
        return response.data.requestOrderNumber;
      } else {
        toast.error(response.message || "Oops, Something went wrong");
      }
    } catch ({ response }) {
      const { message } = response?.data;
      toast.error(message || "Oops, Something went wrong");
    }
  };

  return (
    <NCETranscriptRequestContext.Provider
      value={{
        createTranscript,
        nceTranscriptInfo,
        setNceTranscriptInfo,
        nceTranscriptOption,
        setNceTranscriptOption,
        copyType,
        setCopyType,
        requestType,
        setRequestType,
        nceTranscriptOrderNo,
        setNceTranscriptOrderNo,
      }}
    >
      {children}
    </NCETranscriptRequestContext.Provider>
  );
};
export default NCETranscriptRequestProvider;
